import SecondaryWalletSettings from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletSettings";

export default class AccountSecondaryWalletSettings extends SecondaryWalletSettings {
    overridden: boolean = false;
}